import { FinancialGoalType, WizardState } from '../context/SetGoalProvider';
import {
  EXPENSE_GOAL_STEPS,
  LARGE_PURCHASE_GOAL_STEPS,
  NON_FINANCIAL_GOAL_STEPS,
} from '../SetGoal.meta';

export const getGoalSteps = (wizard: Partial<WizardState>) => {
  if (wizard.isFinancialGoal) {
    return wizard.goalType === FinancialGoalType.Expense
      ? EXPENSE_GOAL_STEPS
      : LARGE_PURCHASE_GOAL_STEPS;
  }

  return NON_FINANCIAL_GOAL_STEPS;
};
